// extracted by mini-css-extract-plugin
module.exports = {"pricing":"Pricing_pricing__RiCpE","price":"Pricing_price__2SqgW","info":"Pricing_info__2rc2o","footer":"Pricing_footer__1Q7tu"};